import { fetchExperiments } from '../store/experiments/action-creators';
import { getPreAcountCreatedExperimentIdentifierPhase } from './ExperimentUtils';
import { isPostVerification } from '../flow-settings/settingsSelectors';
export const setupExperiments = store => {
  if (!isPostVerification()) {
    store.dispatch(fetchExperiments({
      identifierPhase: getPreAcountCreatedExperimentIdentifierPhase()
    }));
  }
};